import styled from 'styled-components';

export const OfferEditCombinationStyles = styled.section`
  .offerGrid {
    margin-top: 40px;
  }
`;
